exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".configure-config-modal .StandardFieldLayout .sm-label-right {\n  min-width: 160px;\n}\n", ""]);

